import { css } from '@emotion/react';

const contactDetailsFormStyles = {
    containerTitle: css({
        fontStyle: 'normal',
        fontWeight: 600,
        fontSize: '15px',
        lineHeight: '15px',
        color: '#000000',
        margin: '4px 0',
        textAlign: 'left',
        paddingLeft: '15px'
    }),
    optionalText: css({
        fontSize: '15px',
        fontWeight: 400,
        marginLeft: '5px',
    }),
    form: css({
        background: '#DAE7FA',
        borderRadius: '8px',
        fontSize: '14px',
        fontWeight: 300,
        textAlign: 'center',
        padding: '15px 20px',
        marginBottom: '2px',
        'input.PhoneInputInput': {
            border: 'none',
            fontSize: '14px',
            background: '#DAE7FA',
        },
        'input.PhoneInputInput:active, input.PhoneInputInput:focus': {
            border: 'none',
            outline: 'none',
        },
    }),
    formEmail: css({
        marginBottom: '2px',
    }),
    input: css({
        background: '#DAE7FA',
        outline: 'none',
        padding: '0',
        width: '100%',
        lineHeight: 1.2,
        border: 'none',
        fontFamily: 'Montserrat',
        fontSize: 14,
        fontWeight: 400,
        textAlign: 'left',

        ['&::placeholder']: {
            color: '#004FC6',
            opacity: '0.5',
            fontSize: 14,
            fontWeight: 400,
            letterSpacing: 1,
            textAlign: 'left',
            fontFamily: 'Montserrat',
        },
    }),
    errorMessage: css({
        display: 'block',
        transition: '0.2s',
        margin: '0 0 20px 0',
        color: '#C10000',
        fontSize: 12,
    }),
    description: css({
        fontWeight: 400,
        fontSize: '13px',
        lineHeight: '16px',
        color: '#000000',
        marginBottom: '20px',
        marginTop: '2px',
    }),
    required: css({
        color: '#C10000',
    }),
    inputWrapper: css({
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        marginBottom: '20px'
    })
};

export default contactDetailsFormStyles;
